import type {
  Candidate,
  CandidateCalendar,
  CandidateRedux,
  UserInterview,
} from '@axiom/validation';

export type InterviewCandidateType = {
  displayName: string;
  calendar?: {
    id: CandidateCalendar['id'] | null;
    timezone: CandidateCalendar['timezone'] | null;
  };
  id: Candidate['id'];
  profileImageKey: Candidate['profileImageKey'];
};

export const useInterviewAvailabilityCandidateData = ({
  candidateRedux,
  candidateInterview,
}: {
  candidateRedux?: CandidateRedux | Candidate;
  candidateInterview?: UserInterview['candidateOpportunity']['candidate'];
}): {
  interviewCandidate: InterviewCandidateType | null;
} => {
  if (!candidateRedux && !candidateInterview) {
    return { interviewCandidate: null };
  }
  /**
   * This is used as a transition from the old Redux
   * and Sagas to our useApi standards
   * */

  return {
    interviewCandidate: {
      displayName:
        candidateRedux?.firstName ??
        candidateInterview?.calculatedDisplayName ??
        'Talent',
      calendar: {
        id:
          candidateRedux?.calendar?.id ??
          candidateInterview?.calendar?.id ??
          null,
        timezone:
          candidateRedux?.calendar?.timezone ??
          candidateInterview?.calendar?.timezone ??
          null,
      },
      id: candidateRedux?.id ?? candidateInterview?.id ?? '',
      profileImageKey:
        candidateRedux?.profileImageKey ??
        candidateInterview?.profileImageKey ??
        null,
    },
  };
};
